import React from 'react'
import Cards from './Cardevent'

const Events = () => {
  return (
    <div>
      <h1 className='text-emerald-800 font-bold text-4xl text-center p-10'>Ucoming Events</h1>
      <Cards/>
    </div>
  )
}

export default Events
